import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#fece2f",
        },
    },

    components: {
        MuiContainer: {
            styleOverrides: {
                root: {},
                maxWidthSm: {
                    paddingLeft: 24,
                    paddingRight: 24,
                },
            },
        },
    },
});

export default theme;
